import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

document.addEventListener("DOMContentLoaded", function() {
    const sliders = document.querySelectorAll('.swiper-testimonials');

    sliders.forEach(function(slider) {
        const container = slider.closest('.swiper-container-parent');

        const swiperInstance = new Swiper(slider, {
            modules: [Pagination, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            slidesPerView: 1,  // Affiche une seule slide à la fois
            spaceBetween: 0,   // Pas d'espace entre les slides
            pagination: {
                el: container.querySelector('.swiper-pagination'), // Sélecteur pour la pagination
                clickable: true,  // Permettre de cliquer sur les dots pour naviguer
            },
            on: {
                init: function () {
                    // Appliquer les animations personnalisées au slide actif lors de l'initialisation
                    const activeSlide = slider.querySelector('.swiper-slide-active');
                    triggerAnimation(activeSlide);
                },
                slideChangeTransitionStart: function () {
                    // Réinitialiser les animations avant de changer de slide
                    resetAllAnimations(slider);
                },
                slideChangeTransitionEnd: function () {
                    // Appliquer les animations après la transition de slide
                    const activeSlide = slider.querySelector('.swiper-slide-active');
                    triggerAnimation(activeSlide);
                }
            }
        });

        function triggerAnimation(slide) {
            // Appliquer les animations personnalisées à l'image et au texte
            const image = slide.querySelector('.company-image img');
            const text = slide.querySelector('.testimonial-card_content');
            if (image) {
                image.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
                image.style.opacity = '1';
                image.style.transform = 'translateX(0)';
            }
            if (text) {
                text.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
                text.style.opacity = '1';
                text.style.transform = 'translateY(0)';
            }
        }

        function resetAllAnimations(slider) {
            const allSlides = slider.querySelectorAll('.swiper-slide');
            allSlides.forEach(slide => {
                const image = slide.querySelector('.company-image img');
                const text = slide.querySelector('.testimonial-card_content');
                if (image) {
                    image.style.transition = 'none';
                    image.style.opacity = '0';
                    image.style.transform = 'translateX(-50px)';
                }
                if (text) {
                    text.style.transition = 'none';
                    text.style.opacity = '0';
                    text.style.transform = 'translateY(50px)';
                }
            });
        }
    });
});
